import React from 'react';
import { Heart } from 'lucide-react';
import { cn } from '@/lib/utils';

const SIZE = {
  sm: { wrap: 'h-7 w-7', icon: 'h-3.5 w-3.5' },
  md: { wrap: 'h-8 w-8', icon: 'h-4 w-4' },
  lg: { wrap: 'h-9 w-9', icon: 'h-5 w-5' },
};

/**
 * Corazón interactivo: el cliente marca/desmarca su like en el producto.
 */
export function ProductFavoriteHeart({
  liked = false,
  onToggle,
  className,
  size = 'md',
  absolute = false,
  disabled = false,
}) {
  const s = SIZE[size] || SIZE.md;
  const label = liked ? 'Quitar me gusta' : 'Me gusta';

  return (
    <button
      type="button"
      disabled={disabled || typeof onToggle !== 'function'}
      className={cn(
        'inline-flex items-center justify-center rounded-full shadow-md ring-1 transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rose-400',
        'disabled:pointer-events-none disabled:opacity-50',
        liked
          ? 'bg-rose-500 text-white ring-rose-400/80 hover:bg-rose-600'
          : 'bg-white/95 text-rose-500 ring-rose-200/80 hover:bg-rose-50',
        s.wrap,
        absolute && 'absolute top-2 right-2 z-10',
        className,
      )}
      title={label}
      aria-label={label}
      aria-pressed={liked}
      data-testid="product-like-heart"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onToggle?.();
      }}
      onPointerDown={(e) => e.stopPropagation()}
    >
      <Heart
        className={cn(s.icon, liked ? 'fill-white text-white' : 'fill-transparent text-rose-500')}
        aria-hidden
      />
    </button>
  );
}
